/**
 * Тема: `data-theme` на <html>. Предпочтение игрока (`settings.theme`)
 * раскрывается в light/dark; «system» следует системной настройке.
 */
export type Theme = 'light' | 'dark';
export type ThemePref = Theme | 'system';

export const THEME_PREFS: readonly ThemePref[] = ['system', 'light', 'dark'];

export function systemTheme(): Theme {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function resolveTheme(pref: ThemePref): Theme {
  return pref === 'system' ? systemTheme() : pref;
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
}
